const transformTimeZonesFromGW = timeZones =>
    timeZones ? timeZones.map(({ name, value }) => ({ label: name, value })) : [];

export default transformTimeZonesFromGW;
